// Global Chart Configuration — sizes mirror globals.css --font-size-* (16px root)

/** Recharts SVG ticks need numeric px; values match design tokens. */
export const CHART_FONT_SIZES = {
  /** --font-size-compact-xs */
  TICK: 10,
  /** --font-size-compact-sm */
  TICK_SM: 11,
  /** --font-size-compact-base */
  TOOLTIP: 12,
  /** --font-size-footnote */
  AXIS: 14,
  LABEL: 14,
  LEGEND: 14,
} as const;

/** SVG ticks: same stack as `globals.css` `--font-family` (CSS var not reliable on all SVG text). */
export const CHART_FONT_FAMILY =
  "Inter, system-ui, -apple-system, sans-serif" as const;

export const CHART_AXIS_TICK = {
  fill: "hsl(var(--muted-foreground))",
  fontFamily: CHART_FONT_FAMILY,
  fontSize: CHART_FONT_SIZES.TICK,
} as const;

/** Larger axis labels (Activity / detail charts). */
export const CHART_AXIS_TICK_LG = {
  fill: "hsl(var(--muted-foreground))",
  fontFamily: CHART_FONT_FAMILY,
  fontSize: CHART_FONT_SIZES.AXIS,
} as const;

export const CHART_TOOLTIP_STYLE = {
  backgroundColor: "hsl(var(--card))",
  border: "1px solid hsl(var(--border))",
  borderRadius: "8px",
  fontSize: CHART_FONT_SIZES.TOOLTIP,
  fontFamily: CHART_FONT_FAMILY,
  padding: "6px 10px",
} as const;

export const CHART_COLORS = {
  PRIMARY: "#2563eb",
  SECONDARY: "#f97316",
  SUCCESS: "#10b981",
  WARNING: "#f59e0b",
  DANGER: "#ef4444",
  INFO: "#3b82f6",
} as const;
